import { lazy } from 'react';

const SettingsApp = lazy(() => import('./SettingsApp'));

const SettingsAppConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  helpConfig: {
    query: 'settings',
    title: 'Settings'
  },
  routes: [
    {
      path: 'apps/settings/:configType?',
      element: <SettingsApp />,
    },
  ],
};

export default SettingsAppConfig;
